import React from 'react'
import behanceIcon from './icons/behance.svg';
import linkedinIcon from './icons/linkedin.svg';
import instagramIcon from './icons/instagram.svg';

export default function Apptop() {
  return (
    
  //   <div class="container container-nav">

  //     <div class="row align-items-start">
  //       <div class="col">

  //   <nav className="navbar navbar-expand-lg bg-body-tertiary">
  //   <div className="container-fluid nav-custom">
  //     <img className="animate__animated animate__slideInDown icon-class-1" src={behanceIcon}/>
  //     <img className="animate__animated animate__slideInDown icon-class-2" src={behanceIcon}/>
  //     <img className="animate__animated animate__slideInDown icon-class-3" src={behanceIcon}/>

  //   {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
  //       <span className="navbar-toggler-icon"></span>
  //   </button>
  //   <div className="collapse navbar-collapse" id="navbarSupportedContent">
  //     <ul className="navbar-nav ms-auto mb-2 mb-lg-0 ">
  //       <li className="nav-item">
  //       <img className="animate__animated animate__slideInDown icon-class-1" src={behanceIcon}/>
  //       </li>
  //       <li className="nav-item">
  //       <img className="animate__animated animate__slideInDown icon-class-2" src={behanceIcon}/>
  //       </li>
  //       <li className="nav-item">
  //       <img className="animate__animated animate__slideInDown icon-class-3" src={behanceIcon}/>
  //       </li>
        
  //     </ul>
  //   </div>
  //      */}
  //   </div>
  // </nav>
  

  // </div>    </div>    </div>

  <div class="d-flex flex-md-row-reverse nav-custom">
       <div class="p-2">
       <a href="https://www.behance.net/kapilananth" target="_blank"><img className="animate__animated animate__backInDown icon-class" src={behanceIcon}/></a>
      </div>
      <div class="p-2">
      <a href="https://www.linkedin.com/in/kapilananth/" target="_blank"><img className="animate__animated animate__backInDown icon-class" src={linkedinIcon}/></a>
      </div>
      <div class="p-2">
      <a href="https://www.instagram.com/the_ps_addict/?i" target="_blank"> <img className="animate__animated animate__backInDown icon-class" src={instagramIcon}/></a>
      </div>
    
  </div>
  )
}
